import { render } from "./PointsCenter.vue?vue&type=template&id=06f1c8ff&scoped=true"
import script from "./PointsCenter.vue?vue&type=script&lang=js"
export * from "./PointsCenter.vue?vue&type=script&lang=js"

import "./PointsCenter.vue?vue&type=style&index=0&id=06f1c8ff&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f1c8ff"]])

export default __exports__